<!--
  组件说明：用户穿梭框
  调用示范：
  <userTransfer :value.sync="yhidList"></userTransfer>
-->
<template>
  <div style="display: flex;">
    <el-dialog title="未匹配名单" :visible.sync="showInvalidDataDialog" :append-to-body="true" width="70%" center>
      <div>
        <div v-for="(invalidData,k) in invalidData" :key="k" style="margin-bottom: 5px;">
          <span>{{invalidData}}</span>
        </div>
      </div>
    </el-dialog>

    <div style="margin-right: 20px;">
      <textarea class="user-textarea-01"
        :placeholder="`文本搜索：输入${desc}名称或账号，用逗号或者换行分开。 点击空白处刷新`"
        @change="search">
      </textarea>

      <div style="display: flex; align-items: center;margin-top: 5px;">
        输入<strong class="global-blue">{{total}}</strong>个{{desc}}信息，<!--
        -->已匹配<strong class="global-blue">{{searchTotal}}</strong>个{{desc}}<!--
        --><template v-if="this.invalidData.length > 0">
          ，
          <el-link type="primary" @click="showInvalidData()" style="font-size: 16px;">未匹配
            <span style="color:red">
              {{this.invalidData.length}}
            </span>个
          </el-link>
        </template>
      </div>
    </div>

    <el-transfer
      :titles="[`${desc}列表`, `已选择的${desc}`]"
      :props="props"
      @change="change"
      filterable
      :filter-method="filterMethod"
      filter-placeholder="输入名称、账号搜索"
      v-model="yhidList"
      :data="data">
      <!-- <span :title="'工号：' + option.yhzh" slot-scope="{ option }">{{ option.yhmc }}</span> -->
      <span :title="'部门：' + option.bmmc" slot-scope="{ option }">{{ option.yhmc }} ({{ option.yhzh }})</span>
    </el-transfer>
  </div>
</template>
<script>
import { getListData } from '@/api/user'
export default {
  data (props) {
    console.log(props.value)
    return {
      data: [],
      invalidData: [],
      showInvalidDataDialog: false,
      yhidList: props.value,
      props: {
        key: 'yhid',
        label: 'yhmc'
      },
      total: 0,
      searchTotal: 0
    }
  },
  props: {
    value: Array,
    desc: {
      type: String,
      default: function () {
        return '考生'
      }
    }
  },
  watch: {
    value (val) {
      this.yhidList = val
      // console.log('watch--->', this.value)
    }
  },
  methods: {
    change () {
      this.$emit('update:value', this.yhidList)
    },
    filterMethod (query, item) {
      return item.yhmc && item.yhzh && (item.yhmc.indexOf(query) > -1 || item.yhzh.indexOf(query) > -1)
    },
    search (event) {
      this.invalidData = []
      const searchText = event.target.value.replace(/[，\r\n]+/g, ',').replace(/\s+/g, '')
      let searchArr = searchText ? searchText.split(',') : []
      searchArr = searchArr.filter(v => v.replace(/(^\s*)|(\s*$)/g, '') !== '')
      this.total = searchArr.length
      this.searchTotal = 0
      searchArr.forEach(search => {
        const user = this.data.find(item => item.yhmc === search || item.yhzh === search)
        if (user != null) {
          this.searchTotal++
          if (!this.yhidList.includes(user.yhid)) {
            this.yhidList.push(user.yhid)
          }
        } else {
          this.invalidData.push(search)
        }
      })
      /*
      this.data.forEach(item => {
        if (searchArr.includes(item.yhmc) || searchArr.includes(item.yhzh)) {
          if (!this.yhidList.includes(item.yhid)) {
            this.searchTotal++
            this.yhidList.push(item.yhid)
          }
        }
      })
      */
    },
    showInvalidData () {
      this.showInvalidDataDialog = true
    }
  },
  created () {
    // 获取用户列表
    getListData().then(res => {
      this.$http.callback(res, () => {
        console.log(res.data)
        this.data = res.data
        // console.log('created--->', this.value)
      })
    })
  }
}
</script>

<style lang="less" scoped>

.user-textarea-01::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
  font-size: 13px;
}

.user-textarea-01 {
  border: none;
  max-width: 400px;
  min-width: 350px;
  width: 400px;
  // width: 100%;
  height: 100%;
  color: #2c3e50;
  font-size: 14px;
  vertical-align: top; // 解决textarea 下面多余的空间

  border: 1px solid #dcd5d5;
  box-shadow: 0 0 .8px #719ECE;
  border-radius: 4px;

  &::placeholder{
    font-size: 14px;
  }

  &:focus {
    outline: none !important;
    border: 1px solid #dcd5d5;
    border-radius: 4px;
    box-shadow: 0 0 3px #719ECE;
  }
}

 /deep/ .el-transfer-panel{
  width: 240px;
 }
</style>
